import React from "react";
import { Box, Typography } from "@mui/material";

const Header = () => {
  return (
    <Box sx={{ p: "22px 30px", textAlign: "left" }}>
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 600,
          lineHeight: "20px",
          color: "#393939",
        }}
      >
        Change Password
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "20px",
          color: "#5C5C5C",
          mt: "20px",
        }}
      >
        Verify your identity to continue
      </Typography>
    </Box>
  );
};

export default Header;
